import { createContext } from 'react';
import { socket } from '../../constants/socket';

export const SocketContext = createContext(socket);
